import React from 'react';
import '../App.css';

function HomePage() {
  return (
    <div className="landing">
      <section className="landing-hero">
        <div className="landing-container">
          <h1>Winston</h1>
          <h2>The incident management app</h2>
          <p>
            Winston connects your Slack channels to Grafana On-call so you can
            ping whoever is on-call with a simple message. No more searching
            through schedules or guessing who to contact.
          </p>
          <a href="/slack/install" className="install-button">
            Add to Slack
          </a>
        </div>
      </section>

      <section className="landing-features">
        <div className="landing-container">
          <div className="features-grid">
            <div className="feature-card">
              <h3>On-call aliases</h3>
              <p>
                Link Grafana On-call schedules to short aliases like{' '}
                <code>!oncall</code>. Type the alias in any channel (that
                Winston is a member of) to instantly ping whoever is on-call.
              </p>
            </div>
            <div className="feature-card">
              <h3>Per-channel configuration</h3>
              <p>
                Each channel gets its own set of aliases. Set up different
                schedules for different teams without any overlap.
              </p>
            </div>
            <div className="feature-card">
              <h3>Grafana On-call integration</h3>
              <p>
                Connects directly to your Grafana On-call instance to pull
                live schedule data and resolve the current on-call user.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-getting-started">
        <div className="landing-container">
          <h2>Getting started</h2>
          <ol className="steps-list">
            <li>
              Click <strong>Add to Slack</strong> above to install Winston in
              your workspace.
            </li>
            <li>
              Open the <strong>Winston App Home</strong> in Slack and configure
              your Grafana On-call API URL and token.
            </li>
            <li>
              In any channel, run{' '}
              <code>/winston schedule !alias schedule-id</code> to link an
              alias to a schedule.
            </li>
            <li>
              Type <code>!alias</code> in the channel to ping the current
              on-call.
            </li>
          </ol>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
